import './NutritionistAIAd.css'
import bg_img from '../../../resources/Union.svg'
import img1 from '../../../resources/abstract-22.svg'
import img2 from '../../../resources/ntai_logo.svg'
import img3 from '../../../resources/Group 33629 (1).svg'
import img4 from '../../../resources/send.svg'
import img5 from '../../../resources/Ellipse 158.png'
import { useNavigate } from 'react-router-dom';

function NutritionistAIAd() {
    const navigate = useNavigate(); // This hook is now properly imported
    return (
        <div className="dashboard-nutrition-ai-all-div font_family_inter white">
            <div className='dashboard-nutrition-ai-bg-color-bottom-div'>
                <div className='dashboard-nutrition-ai-bg-color-bottom-left'></div>
                <div className='dashboard-nutrition-ai-bg-color-bottom-right'></div>
                <div className='dashboard-nutrition-ai-bg-color-top-right'></div>
            </div>

            <div className='dashboard-nutrition-ai-all-inner-div flex'>
                <div className='dashboard-nutritionist-ai-text-left-div'>
                    <div className="dashboard-nutritionist-ai-parent">
                        <p className='font_weight_600 font_size_16 no_margin'>Nutritionist AI</p>
                        <img className="abstract-22-icon" alt="" src={img1} />
                    </div>
                    <h3 className='dashboard-nutrition-ai-text font_weight_600'>Unlock Your Personalized Nutrition Advice!</h3>
                    <a href='/premium' className='text_decoration_none'>
                        <div className="dashboard-nutrition-ai-button nutritionist-ad-full-window-display">
                            <p className='no_margin font_weight_600 white'>Go Premium</p>
                        </div>
                    </a>
                </div>

                <div className="dashboard-nutrition-ai-frame-group">
                    <div className="dashboard-nutrition-ai-group-container">
                        <div className="dashboard-nutritionist-ai-group">
                            <p className="green_gradient_p no_margin">Nutritionist AI</p>
                            <img className="abstract-22-icon1" alt="" src={img2} />
                        </div>
                        <img className="frame-inner" alt="" src={img3} />
                    </div>
                    <div className="dashboard-nutrition-ai-frame-container">
                        <div className="rectangle-group">
                            <div className="rectangle-div">
                            </div>
                            <div className="frame-child1">
                            </div>
                        </div>
                        <img className="ellipse-icon" alt="" src={img5} />
                    </div>
                    <div className="dashboard-nutrition-ai-ellipse-parent">
                        <svg xmlns="http://www.w3.org/2000/svg" width="23.7" height="23.7" viewBox="0 0 41 41" fill="none">
                            <circle cx="20.8247" cy="20.6788" r="20" fill="url(#paint0_linear_190_6088)" />
                            <path d="M27.7333 18.4954H20.9702V11.6138C20.9421 11.402 20.8515 11.2033 20.7101 11.0431C20.5687 10.8829 20.3829 10.7683 20.1762 10.7141C19.9695 10.6598 19.7513 10.6682 19.5495 10.7383C19.3476 10.8084 19.1711 10.937 19.0425 11.1077L13.2702 21.1985C13.1782 21.3622 13.1306 21.5472 13.1321 21.735C13.1337 21.9228 13.1843 22.107 13.279 22.2692C13.3737 22.4314 13.5092 22.566 13.672 22.6596C13.8348 22.7533 14.0193 22.8027 14.2071 22.8031H20.9702V29.6846C20.9984 29.8964 21.0889 30.0951 21.2303 30.2553C21.3717 30.4156 21.5576 30.5301 21.7643 30.5844C21.971 30.6387 22.1891 30.6302 22.391 30.5601C22.5929 30.49 22.7693 30.3614 22.8979 30.1908L28.6702 20.1C28.7623 19.9363 28.8099 19.7513 28.8083 19.5635C28.8068 19.3756 28.7562 19.1915 28.6614 19.0293C28.5667 18.8671 28.4312 18.7325 28.2684 18.6388C28.1056 18.5451 27.9211 18.4957 27.7333 18.4954Z" fill="white" />
                            <defs>
                                <linearGradient id="paint0_linear_190_6088" x1="11.6749" y1="7.9399" x2="40.9899" y2="40.6115" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#235539" />
                                    <stop offset="1" stopColor="#7B946B" />
                                </linearGradient>
                            </defs>
                        </svg>
                        <div className="rectangle-container">
                            <div className="frame-child3">
                            </div>
                            <div className="frame-child4">
                            </div>
                            <div className="frame-child5">
                            </div>
                        </div>
                    </div>
                    <div className="dashboard-nutrition-ai-frame-div">
                        <div className="frame-child6">
                        </div>
                        <div className="vuesaxboldsend-wrapper">
                            <img className="vuesaxboldsend-icon" alt="" src={img4} />
                        </div>
                    </div>
                </div>


                <div className="dashboard-nutrition-ai-button nutritionist-ad-mobile-display">
                    <p className='no_margin font_weight_600'>Go Premium</p>
                </div>
            </div>
        </div>
    );
}


export default NutritionistAIAd;